/**
 * Application Version Configuration
 * Update this file when releasing new versions
 */

export const APP_VERSION = {
  version: '2.5',
  releaseDate: '2025-05-01',
  releaseTime: '05:10',
  buildNumber: 1,
  
  // What's new in this version
  changelog: [
    'Customer & Supplier Excel Import with opening balance vouchers',
    'Dual-currency POS payment system',
    'Granular action-level permissions (View, Add, Edit, Delete, Print, AI)',
    'Purchase Order revert functionality',
    'Batch edit capability in Inventory',
    'Bulk delete inventory tool',
    'Enhanced customer search in POS',
    'Fixed purchase invoice VAT posting',
    'Item movement currency display fix',
  ]
};

// Formatted version string for display
export const getVersionString = (format = 'short') => {
  const { version, releaseDate, releaseTime } = APP_VERSION;
  
  switch (format) {
    case 'short':
      // v2.5 • May 1
      const shortDate = new Date(releaseDate).toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
      return `v${version} • ${shortDate}`;
    
    case 'medium':
      // v2.5 (May 1, 2025)
      const mediumDate = new Date(releaseDate).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
      return `v${version} (${mediumDate})`;
    
    case 'full':
      // Version 2.5 • Released: May 1, 2025 at 05:10
      const fullDate = new Date(releaseDate).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
      return `Version ${version} • Released: ${fullDate} at ${releaseTime}`;
    
    default:
      return `v${version}`;
  }
};

export default APP_VERSION;
